import React, { useCallback } from 'react';

import dayjs from 'dayjs';
import isNull from 'lodash/isNull';
import PropTypes from 'prop-types';

import { getCorrectedDate } from 'utils/date';

import DateFieldCDS from '../../form/DateFieldCDS';

const FormGeneratorDateFieldCDS = ({
  name,
  value = null,
  setInForm,
  validateField,
  dataTestId,
  maxDate,
  minDate,
  noValidate = false,
  ...props
}) => {
  const onChange = useCallback(
    date => {
      if (isNull(date)) {
        setInForm(name, null);

        if (!noValidate) {
          validateField(name, null);
        }

        return;
      }

      const dateMoment = dayjs(date);

      if (dateMoment.isValid()) {
        setInForm(name, dateMoment);

        if (!noValidate) {
          validateField(name, dateMoment);
        }
      }
    },
    [setInForm, name, validateField, noValidate],
  );

  const onBlur = useCallback(
    date => {
      const newValue = dayjs(date).isValid() ? dayjs(date) : null;

      setInForm(name, newValue);

      if (!noValidate) {
        validateField(name, newValue);
      }
    },
    [name, setInForm, validateField, noValidate],
  );

  const onFocus = useCallback(() => {
    if (isNull(value) || dayjs(value).isValid()) {
      return;
    }

    const correctedDate = getCorrectedDate(value, { minDate, maxDate });

    const dateMoment = dayjs(correctedDate);
    setInForm(name, dateMoment);

    if (!noValidate) {
      validateField(name, dateMoment);
    }
  }, [value, minDate, maxDate, setInForm, name, validateField, noValidate]);

  return (
    <DateFieldCDS
      {...props}
      dataTestId={dataTestId}
      maxDate={maxDate}
      minDate={minDate}
      name={name}
      noValidate={noValidate}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
    />
  );
};

FormGeneratorDateFieldCDS.propTypes = {
  error: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  validateField: PropTypes.func.isRequired,
  setInForm: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  helperText: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  required: PropTypes.bool,
  noValidate: PropTypes.bool,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  margin: PropTypes.string,
  width: PropTypes.string,
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  dataTestId: PropTypes.string,
  withTime: PropTypes.bool,
};

export default FormGeneratorDateFieldCDS;
